import script from "./QuotationListView.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotationListView.vue?vue&type=script&setup=true&lang=js"

import "./QuotationListView.vue?vue&type=style&index=0&id=13fe895c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13fe895c"]])

export default __exports__